export default "__VITE_ASSET__CplZrXp___"